"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getUnknownParticipantNameForParticipantAtLastName = exports.isParticipantClipped = exports.isTimestampClipped = exports.isUnknownParticipantName = exports.getUnknownParticipantNameForParticipantAt = exports.isUnknownParticipantId = exports.getUnknownParticipantId = exports.UNKNOWN_PARTICIPANT_NAME_PREFIX = exports.UNKNOWN_PARTICIPANT_ID_PREFIX = void 0;
const randomizer_1 = require("./randomizer");
exports.UNKNOWN_PARTICIPANT_ID_PREFIX = "UNKNOWN_";
exports.UNKNOWN_PARTICIPANT_NAME_PREFIX = "Participant at ";
function getUnknownParticipantId() {
    return exports.UNKNOWN_PARTICIPANT_ID_PREFIX + (0, randomizer_1.newUUID)();
}
exports.getUnknownParticipantId = getUnknownParticipantId;
function isUnknownParticipantId(id) {
    return id.includes(exports.UNKNOWN_PARTICIPANT_ID_PREFIX);
}
exports.isUnknownParticipantId = isUnknownParticipantId;
function getUnknownParticipantNameForParticipantAt(audioTimestamp) {
    return exports.UNKNOWN_PARTICIPANT_NAME_PREFIX + audioTimestamp;
}
exports.getUnknownParticipantNameForParticipantAt = getUnknownParticipantNameForParticipantAt;
function isUnknownParticipantName(fullName) {
    return fullName.includes(exports.UNKNOWN_PARTICIPANT_NAME_PREFIX);
}
exports.isUnknownParticipantName = isUnknownParticipantName;
function isTimestampClipped(timestamp) {
    return timestamp !== null && timestamp !== undefined && timestamp.trim() !== "";
}
exports.isTimestampClipped = isTimestampClipped;
function isParticipantClipped(participantData) {
    return (isTimestampClipped(participantData.audioStartTimestamp) ||
        isTimestampClipped(participantData.audioEndTimestamp) ||
        isTimestampClipped(participantData.clipStartTimestamp) ||
        isTimestampClipped(participantData.clipEndTimestamp));
}
exports.isParticipantClipped = isParticipantClipped;
function getUnknownParticipantNameForParticipantAtLastName(audioTimestamp) {
    return audioTimestamp;
}
exports.getUnknownParticipantNameForParticipantAtLastName = getUnknownParticipantNameForParticipantAtLastName;
//# sourceMappingURL=unkown-participants.js.map